import { Box, DashboardModule } from '@domain-group/suit-theme'

import useAgencySelector from '@hooks/useAgencySelector'
import useUsers from '@hooks/useUsers'

import UserListItem from '../UserListItem'
import UsersBlankState from '../UsersBlankState'

interface PageContentProps {
  pageFilters: {
    [key: string]: any,
  },
}

const BrandUsers = (props: PageContentProps) => {
  const { pageFilters } = props

  const { selectedAgencyId } = useAgencySelector()

  const usersPayload = useUsers({
    filters: {
      actable_types: ['OfficeAdministrator'],
      agency_id: selectedAgencyId,
      brand_user: true,
      ...pageFilters,
    },
    performHttpRequests: true,
    requestOptions: {
      include_image_sizes: true,
      include_user_association_id: true,
      include_user_image: true,
      include_user_type: true,
    },
  })

  const {
    callbacks: { loadMore },
    canLoadMore,
    filteredUsers,
    filteredUsersCount,
    hasFilteredUsers,
    loading,
  } = usersPayload

  return (
    <DashboardModule
      boxProps={{ borderBottom: loading ? 'none' : '1px solid lineColor' }}
      loading={loading}
      title="Brand Users"
    >
      <Box flexDirection="column">
        {!loading && !hasFilteredUsers && <UsersBlankState title="No Brand Users" />}

        {!loading && hasFilteredUsers && (
          <DashboardModule.ScrollableSection>
            {filteredUsers.map(user => (
              <UserListItem
                // @ts-expect-error TS2322
                agencyId={selectedAgencyId}
                key={user.id}
                user={user}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        {!loading && (
          <DashboardModule.LoadMoreFooter
            boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
            callbacks={{ loadMore }}
            canLoadMore={canLoadMore}
            entityCount={filteredUsersCount}
            // @ts-expect-error TS2322
            loading={loading}
          />
        )}
      </Box>
    </DashboardModule>
  )
}

export default BrandUsers
